import type { Proposal } from '@sab/core/schemas';
import { SlideRenderer, type SlideRendererContext } from './SlideRenderer.tsx';

interface DeckProps {
  proposal: Proposal;
  contactEmail?: string;
  contactName?: string;
  contactPhone?: string;
}

export function Deck({ proposal, contactEmail, contactName, contactPhone }: DeckProps) {
  const ctx: SlideRendererContext = {
    total: proposal.slides.length,
    companyName: proposal.prospect.companyName,
    date: proposal.publishedAt ?? proposal.updatedAt,
    ...(contactEmail !== undefined ? { contactEmail } : {}),
    ...(contactName !== undefined ? { contactName } : {}),
    ...(contactPhone !== undefined ? { contactPhone } : {}),
  };

  const sorted = [...proposal.slides].sort((a, b) => a.index - b.index);

  return (
    <main className="sab-deck__shell" aria-label={`Proposal untuk ${proposal.prospect.companyName}`}>
      {sorted.map((s) => (
        <SlideRenderer key={s.id} slide={s} ctx={ctx} />
      ))}
    </main>
  );
}
